import { LitElement as $e, css as Ae, html as z, nothing as ye } from "lit";
import { property as K } from "lit/decorators.js";
function be(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
const Se = {
  aa: {
    name: "Afar",
    nativeName: "Afaraf"
  },
  ab: {
    name: "Abkhaz",
    nativeName: "аҧсуа бызшәа"
  },
  ae: {
    name: "Avestan",
    nativeName: "avesta"
  },
  af: {
    name: "Afrikaans",
    nativeName: "Afrikaans"
  },
  ak: {
    name: "Akan",
    nativeName: "Akan"
  },
  am: {
    name: "Amharic",
    nativeName: "አማርኛ"
  },
  an: {
    name: "Aragonese",
    nativeName: "aragonés"
  },
  ar: {
    name: "Arabic",
    nativeName: "اَلْعَرَبِيَّةُ"
  },
  as: {
    name: "Assamese",
    nativeName: "অসমীয়া"
  },
  av: {
    name: "Avaric",
    nativeName: "авар мацӀ"
  },
  ay: {
    name: "Aymara",
    nativeName: "aymar aru"
  },
  az: {
    name: "Azerbaijani",
    nativeName: "azərbaycan dili"
  },
  ba: {
    name: "Bashkir",
    nativeName: "башҡорт теле"
  },
  be: {
    name: "Belarusian",
    nativeName: "беларуская мова"
  },
  bg: {
    name: "Bulgarian",
    nativeName: "български език"
  },
  bi: {
    name: "Bislama",
    nativeName: "Bislama"
  },
  bm: {
    name: "Bambara",
    nativeName: "bamanankan"
  },
  bn: {
    name: "Bengali",
    nativeName: "বাংলা"
  },
  bo: {
    name: "Tibetan",
    nativeName: "བོད་ཡིག"
  },
  br: {
    name: "Breton",
    nativeName: "brezhoneg"
  },
  bs: {
    name: "Bosnian",
    nativeName: "bosanski jezik"
  },
  ca: {
    name: "Catalan",
    nativeName: "Català"
  },
  ce: {
    name: "Chechen",
    nativeName: "нохчийн мотт"
  },
  ch: {
    name: "Chamorro",
    nativeName: "Chamoru"
  },
  co: {
    name: "Corsican",
    nativeName: "corsu"
  },
  cr: {
    name: "Cree",
    nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"
  },
  cs: {
    name: "Czech",
    nativeName: "čeština"
  },
  cu: {
    name: "Old Church Slavonic",
    nativeName: "ѩзыкъ словѣньскъ"
  },
  cv: {
    name: "Chuvash",
    nativeName: "чӑваш чӗлхи"
  },
  cy: {
    name: "Welsh",
    nativeName: "Cymraeg"
  },
  da: {
    name: "Danish",
    nativeName: "Dansk"
  },
  de: {
    name: "German",
    nativeName: "Deutsch"
  },
  dv: {
    name: "Divehi",
    nativeName: "ދިވެހި"
  },
  dz: {
    name: "Dzongkha",
    nativeName: "རྫོང་ཁ"
  },
  ee: {
    name: "Ewe",
    nativeName: "Eʋegbe"
  },
  el: {
    name: "Greek",
    nativeName: "Ελληνικά"
  },
  en: {
    name: "English",
    nativeName: "English"
  },
  eo: {
    name: "Esperanto",
    nativeName: "Esperanto"
  },
  es: {
    name: "Spanish",
    nativeName: "Español"
  },
  et: {
    name: "Estonian",
    nativeName: "eesti"
  },
  eu: {
    name: "Basque",
    nativeName: "euskara"
  },
  fa: {
    name: "Persian",
    nativeName: "فارسی"
  },
  ff: {
    name: "Fula",
    nativeName: "Fulfulde"
  },
  fi: {
    name: "Finnish",
    nativeName: "suomi"
  },
  fj: {
    name: "Fijian",
    nativeName: "vosa Vakaviti"
  },
  fo: {
    name: "Faroese",
    nativeName: "Føroyskt"
  },
  fr: {
    name: "French",
    nativeName: "Français"
  },
  fy: {
    name: "Western Frisian",
    nativeName: "Frysk"
  },
  ga: {
    name: "Irish",
    nativeName: "Gaeilge"
  },
  gd: {
    name: "Scottish Gaelic",
    nativeName: "Gàidhlig"
  },
  gl: {
    name: "Galician",
    nativeName: "galego"
  },
  gn: {
    name: "Guaraní",
    nativeName: "Avañe'ẽ"
  },
  gu: {
    name: "Gujarati",
    nativeName: "ગુજરાતી"
  },
  gv: {
    name: "Manx",
    nativeName: "Gaelg"
  },
  ha: {
    name: "Hausa",
    nativeName: "هَوُسَ"
  },
  he: {
    name: "Hebrew",
    nativeName: "עברית"
  },
  hi: {
    name: "Hindi",
    nativeName: "हिन्दी"
  },
  ho: {
    name: "Hiri Motu",
    nativeName: "Hiri Motu"
  },
  hr: {
    name: "Croatian",
    nativeName: "Hrvatski"
  },
  ht: {
    name: "Haitian",
    nativeName: "Kreyòl ayisyen"
  },
  hu: {
    name: "Hungarian",
    nativeName: "magyar"
  },
  hy: {
    name: "Armenian",
    nativeName: "Հայերեն"
  },
  hz: {
    name: "Herero",
    nativeName: "Otjiherero"
  },
  ia: {
    name: "Interlingua",
    nativeName: "Interlingua"
  },
  id: {
    name: "Indonesian",
    nativeName: "Bahasa Indonesia"
  },
  ie: {
    name: "Interlingue",
    nativeName: "Interlingue"
  },
  ig: {
    name: "Igbo",
    nativeName: "Asụsụ Igbo"
  },
  ii: {
    name: "Nuosu",
    nativeName: "ꆈꌠ꒿ Nuosuhxop"
  },
  ik: {
    name: "Inupiaq",
    nativeName: "Iñupiaq"
  },
  io: {
    name: "Ido",
    nativeName: "Ido"
  },
  is: {
    name: "Icelandic",
    nativeName: "Íslenska"
  },
  it: {
    name: "Italian",
    nativeName: "Italiano"
  },
  iu: {
    name: "Inuktitut",
    nativeName: "ᐃᓄᒃᑎᑐᑦ"
  },
  ja: {
    name: "Japanese",
    nativeName: "日本語"
  },
  jv: {
    name: "Javanese",
    nativeName: "basa Jawa"
  },
  ka: {
    name: "Georgian",
    nativeName: "ქართული"
  },
  kg: {
    name: "Kongo",
    nativeName: "Kikongo"
  },
  ki: {
    name: "Kikuyu",
    nativeName: "Gĩkũyũ"
  },
  kj: {
    name: "Kwanyama",
    nativeName: "Kuanyama"
  },
  kk: {
    name: "Kazakh",
    nativeName: "қазақ тілі"
  },
  kl: {
    name: "Kalaallisut",
    nativeName: "kalaallisut"
  },
  km: {
    name: "Khmer",
    nativeName: "ខេមរភាសា"
  },
  kn: {
    name: "Kannada",
    nativeName: "ಕನ್ನಡ"
  },
  ko: {
    name: "Korean",
    nativeName: "한국어"
  },
  kr: {
    name: "Kanuri",
    nativeName: "Kanuri"
  },
  ks: {
    name: "Kashmiri",
    nativeName: "कश्मीरी"
  },
  ku: {
    name: "Kurdish",
    nativeName: "Kurdî"
  },
  kv: {
    name: "Komi",
    nativeName: "коми кыв"
  },
  kw: {
    name: "Cornish",
    nativeName: "Kernewek"
  },
  ky: {
    name: "Kyrgyz",
    nativeName: "Кыргызча"
  },
  la: {
    name: "Latin",
    nativeName: "latine"
  },
  lb: {
    name: "Luxembourgish",
    nativeName: "Lëtzebuergesch"
  },
  lg: {
    name: "Ganda",
    nativeName: "Luganda"
  },
  li: {
    name: "Limburgish",
    nativeName: "Limburgs"
  },
  ln: {
    name: "Lingala",
    nativeName: "Lingála"
  },
  lo: {
    name: "Lao",
    nativeName: "ພາສາລາວ"
  },
  lt: {
    name: "Lithuanian",
    nativeName: "lietuvių kalba"
  },
  lu: {
    name: "Luba-Katanga",
    nativeName: "Kiluba"
  },
  lv: {
    name: "Latvian",
    nativeName: "latviešu valoda"
  },
  mg: {
    name: "Malagasy",
    nativeName: "fiteny malagasy"
  },
  mh: {
    name: "Marshallese",
    nativeName: "Kajin M̧ajeļ"
  },
  mi: {
    name: "Māori",
    nativeName: "te reo Māori"
  },
  mk: {
    name: "Macedonian",
    nativeName: "македонски јазик"
  },
  ml: {
    name: "Malayalam",
    nativeName: "മലയാളം"
  },
  mn: {
    name: "Mongolian",
    nativeName: "Монгол хэл"
  },
  mr: {
    name: "Marathi",
    nativeName: "मराठी"
  },
  ms: {
    name: "Malay",
    nativeName: "Bahasa Melayu"
  },
  mt: {
    name: "Maltese",
    nativeName: "Malti"
  },
  my: {
    name: "Burmese",
    nativeName: "ဗမာစာ"
  },
  na: {
    name: "Nauru",
    nativeName: "Dorerin Naoero"
  },
  nb: {
    name: "Norwegian Bokmål",
    nativeName: "Norsk bokmål"
  },
  nd: {
    name: "Northern Ndebele",
    nativeName: "isiNdebele"
  },
  ne: {
    name: "Nepali",
    nativeName: "नेपाली"
  },
  ng: {
    name: "Ndonga",
    nativeName: "Owambo"
  },
  nl: {
    name: "Dutch",
    nativeName: "Nederlands"
  },
  nn: {
    name: "Norwegian Nynorsk",
    nativeName: "Norsk nynorsk"
  },
  no: {
    name: "Norwegian",
    nativeName: "Norsk"
  },
  nr: {
    name: "Southern Ndebele",
    nativeName: "isiNdebele"
  },
  nv: {
    name: "Navajo",
    nativeName: "Diné bizaad"
  },
  ny: {
    name: "Chichewa",
    nativeName: "chiCheŵa"
  },
  oc: {
    name: "Occitan",
    nativeName: "occitan"
  },
  oj: {
    name: "Ojibwe",
    nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"
  },
  om: {
    name: "Oromo",
    nativeName: "Afaan Oromoo"
  },
  or: {
    name: "Oriya",
    nativeName: "ଓଡ଼ିଆ"
  },
  os: {
    name: "Ossetian",
    nativeName: "ирон æвзаг"
  },
  pa: {
    name: "Panjabi",
    nativeName: "ਪੰਜਾਬੀ"
  },
  pi: {
    name: "Pāli",
    nativeName: "पाऴि"
  },
  pl: {
    name: "Polish",
    nativeName: "Polski"
  },
  ps: {
    name: "Pashto",
    nativeName: "پښتو"
  },
  pt: {
    name: "Portuguese",
    nativeName: "Português"
  },
  qu: {
    name: "Quechua",
    nativeName: "Runa Simi"
  },
  rm: {
    name: "Romansh",
    nativeName: "rumantsch grischun"
  },
  rn: {
    name: "Kirundi",
    nativeName: "Ikirundi"
  },
  ro: {
    name: "Romanian",
    nativeName: "Română"
  },
  ru: {
    name: "Russian",
    nativeName: "Русский"
  },
  rw: {
    name: "Kinyarwanda",
    nativeName: "Ikinyarwanda"
  },
  sa: {
    name: "Sanskrit",
    nativeName: "संस्कृतम्"
  },
  sc: {
    name: "Sardinian",
    nativeName: "sardu"
  },
  sd: {
    name: "Sindhi",
    nativeName: "सिन्धी"
  },
  se: {
    name: "Northern Sami",
    nativeName: "Davvisámegiella"
  },
  sg: {
    name: "Sango",
    nativeName: "yângâ tî sängö"
  },
  si: {
    name: "Sinhala",
    nativeName: "සිංහල"
  },
  sk: {
    name: "Slovak",
    nativeName: "slovenčina"
  },
  sl: {
    name: "Slovenian",
    nativeName: "slovenščina"
  },
  sm: {
    name: "Samoan",
    nativeName: "gagana fa'a Samoa"
  },
  sn: {
    name: "Shona",
    nativeName: "chiShona"
  },
  so: {
    name: "Somali",
    nativeName: "Soomaaliga"
  },
  sq: {
    name: "Albanian",
    nativeName: "Shqip"
  },
  sr: {
    name: "Serbian",
    nativeName: "српски језик"
  },
  ss: {
    name: "Swati",
    nativeName: "SiSwati"
  },
  st: {
    name: "Southern Sotho",
    nativeName: "Sesotho"
  },
  su: {
    name: "Sundanese",
    nativeName: "Basa Sunda"
  },
  sv: {
    name: "Swedish",
    nativeName: "Svenska"
  },
  sw: {
    name: "Swahili",
    nativeName: "Kiswahili"
  },
  ta: {
    name: "Tamil",
    nativeName: "தமிழ்"
  },
  te: {
    name: "Telugu",
    nativeName: "తెలుగు"
  },
  tg: {
    name: "Tajik",
    nativeName: "тоҷикӣ"
  },
  th: {
    name: "Thai",
    nativeName: "ไทย"
  },
  ti: {
    name: "Tigrinya",
    nativeName: "ትግርኛ"
  },
  tk: {
    name: "Turkmen",
    nativeName: "Türkmençe"
  },
  tl: {
    name: "Tagalog",
    nativeName: "Wikang Tagalog"
  },
  tn: {
    name: "Tswana",
    nativeName: "Setswana"
  },
  to: {
    name: "Tonga",
    nativeName: "faka Tonga"
  },
  tr: {
    name: "Turkish",
    nativeName: "Türkçe"
  },
  ts: {
    name: "Tsonga",
    nativeName: "Xitsonga"
  },
  tt: {
    name: "Tatar",
    nativeName: "татар теле"
  },
  tw: {
    name: "Twi",
    nativeName: "Twi"
  },
  ty: {
    name: "Tahitian",
    nativeName: "Reo Tahiti"
  },
  ug: {
    name: "Uyghur",
    nativeName: "ئۇيغۇرچە‎"
  },
  uk: {
    name: "Ukrainian",
    nativeName: "Українська"
  },
  ur: {
    name: "Urdu",
    nativeName: "اردو"
  },
  uz: {
    name: "Uzbek",
    nativeName: "Ўзбек"
  },
  ve: {
    name: "Venda",
    nativeName: "Tshivenḓa"
  },
  vi: {
    name: "Vietnamese",
    nativeName: "Tiếng Việt"
  },
  vo: {
    name: "Volapük",
    nativeName: "Volapük"
  },
  wa: {
    name: "Walloon",
    nativeName: "walon"
  },
  wo: {
    name: "Wolof",
    nativeName: "Wollof"
  },
  xh: {
    name: "Xhosa",
    nativeName: "isiXhosa"
  },
  yi: {
    name: "Yiddish",
    nativeName: "ייִדיש"
  },
  yo: {
    name: "Yoruba",
    nativeName: "Yorùbá"
  },
  za: {
    name: "Zhuang",
    nativeName: "Saɯ cueŋƅ"
  },
  zh: {
    name: "Chinese",
    nativeName: "中文"
  },
  zu: {
    name: "Zulu",
    nativeName: "isiZulu"
  }
};
var Ee = Se;
const E = Ee, me = {}, H = {}, he = [], ce = [], ue = [];
for (const i in E) {
  const { name: e, nativeName: t } = E[i];
  me[i] = H[e.toLowerCase()] = H[t.toLowerCase()] = { code: i, name: e, nativeName: t }, he.push(i), ce.push(e), ue.push(t);
}
var we = class L {
  static getLanguages(e = []) {
    return e.map(
      (t) => L.validate(t) ? Object.assign({}, me[t]) : { code: t, name: "", nativeName: "" }
    );
  }
  static getName(e) {
    return L.validate(e) ? E[e].name : "";
  }
  static getAllNames() {
    return ce.slice();
  }
  static getNativeName(e) {
    return L.validate(e) ? E[e].nativeName : "";
  }
  static getAllNativeNames() {
    return ue.slice();
  }
  static getCode(e) {
    return e = e.toLowerCase(), H.hasOwnProperty(e) ? H[e].code : "";
  }
  static getAllCodes() {
    return he.slice();
  }
  static validate(e) {
    return E.hasOwnProperty(e);
  }
};
const de = /* @__PURE__ */ be(we), W = de.getAllCodes(), q = (i) => de.getNativeName(i), ke = "@media (width < 768px){.language-switch__label--full{display:none}}@media (width >= 768px){.language-switch__label--abbreviation{display:none}}";
var Ce = Object.defineProperty, D = (i, e, t, a) => {
  for (var n = void 0, r = i.length - 1, s; r >= 0; r--)
    (s = i[r]) && (n = s(e, t, n) || n);
  return n && Ce(e, t, n), n;
};
const Ue = "muse-language-switch";
var v;
const I = (v = class extends $e {
  constructor() {
    super(...arguments), this._handleItemClickCurry = (e) => (t) => {
      if (console.log(e, this._selected), e === this._selected) {
        t.preventDefault();
        return;
      }
      this._handleLanguageSwitch(e);
    };
  }
  /**
   * @ignore
   */
  static get styles() {
    return Ae([ke]);
  }
  //#endregion
  //#region -- DOM References
  //#endregion
  //#region -- Computed
  /**
   * @ignore
   */
  get _languages() {
    const e = typeof this.languages == "string" ? this.languages.split(",") : this.languages || [], t = e == null ? void 0 : e.filter(
      (n) => W.includes(n)
    );
    if (t && t.length > 0)
      return t;
    const a = document.querySelectorAll('link[rel="alternate"][hreflang]');
    return a.length > 0 ? [...a].map((n) => n.getAttribute("hreflang")) : [v._DEFAULT_LANGUAGE];
  }
  /**
   * returns the selected language from the selected property
   * and falls back to html lang attribute or the final fallback
   * LanguageSwitch._DEFAULT_LANGUAGE
   *
   * @ignore
   */
  get _selected() {
    var t;
    if (this.selected && ((t = this._languages) != null && t.includes(this.selected)))
      return this.selected;
    const e = document.documentElement.lang;
    return e && this._languages.includes(e) ? e : v._DEFAULT_LANGUAGE;
  }
  //#endregion
  //#region -- Lifecycles
  //#endregion
  //#region -- Methods
  /**
   * Handles the logic to switch languages when a language is selected.
   *
   * @param {string} lang - The language code to switch to.
   */
  _modifyUrl(e) {
    const t = new URL(window.location.href).pathname.split("/").filter(Boolean);
    t[0] || (t[0] = this.firstPathSegment), t[1] && W.includes(t[1].toLowerCase()) ? t[1] = e.toUpperCase() : t.splice(1, 0, e.toUpperCase());
    const a = new URL(window.location.href);
    return a.pathname = t.join("/"), a;
  }
  //#endregion
  //#region -- Events
  /**
   * Handles the logic to switch languages when a language is selected.
   *
   * @ignore
   * @param {string} lang - The language code to switch to.
   */
  _handleLanguageSwitch(e) {
    this.dispatchEvent(
      // in case the parent component needs to prevent or intercept navigation:
      // <muse-language-switch
      //    onClick={(ev)=> ev.preventDefault()}
      //    onLanguageswitch={(ev) => handleLangSwitchAttempt(ev.detail)}
      //    ... />
      new CustomEvent("languageswitch", {
        detail: { selected: e, url: this._modifyUrl(e) }
      })
    );
  }
  //#endregion
  //#region -- Render
  render() {
    return z`
      <muse-meta-item-group always-collapsed>
        <span slot="trigger-label">
          <span class="language-switch__label--full">
            ${q(this._selected)}
          </span>

          <span class="language-switch__label--abbreviation">
            ${this._selected.toLocaleUpperCase()}
          </span>
        </span>

        <muse-icon name="globe" slot="trigger-icon"></muse-icon>

        ${this._languages.map(
      (e) => z`
            <muse-meta-item
              href=${this._modifyUrl(e).toString()}
              @click=${this._handleItemClickCurry(e)}
            >
              ${q(e)}
              ${this._selected === e ? z`
                    <muse-icon name="check" slot="icon-end"></muse-icon>
                  ` : ye}
            </muse-meta-item>
          `
    )}
      </muse-meta-item-group>
    `;
  }
  //#endregion
}, v.shadowRootOptions = {
  mode: "open",
  delegatesFocus: !0
}, v._DEFAULT_LANGUAGE = "de", v);
D([
  K()
], I.prototype, "languages");
D([
  K()
], I.prototype, "firstPathSegment");
D([
  K()
], I.prototype, "selected");
let Pe = I;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const O = globalThis, F = O.ShadowRoot && (O.ShadyCSS === void 0 || O.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, ve = Symbol(), J = /* @__PURE__ */ new WeakMap();
let Te = class {
  constructor(i, e, t) {
    if (this._$cssResult$ = !0, t !== ve) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = i, this.t = e;
  }
  get styleSheet() {
    let i = this.o;
    const e = this.t;
    if (F && i === void 0) {
      const t = e !== void 0 && e.length === 1;
      t && (i = J.get(e)), i === void 0 && ((this.o = i = new CSSStyleSheet()).replaceSync(this.cssText), t && J.set(e, i));
    }
    return i;
  }
  toString() {
    return this.cssText;
  }
};
const Le = (i) => new Te(typeof i == "string" ? i : i + "", void 0, ve), Oe = (i, e) => {
  if (F) i.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet);
  else for (const t of e) {
    const a = document.createElement("style"), n = O.litNonce;
    n !== void 0 && a.setAttribute("nonce", n), a.textContent = t.cssText, i.appendChild(a);
  }
}, Y = F ? (i) => i : (i) => i instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const a of e.cssRules) t += a.cssText;
  return Le(t);
})(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Me, defineProperty: He, getOwnPropertyDescriptor: xe, getOwnPropertyNames: Re, getOwnPropertySymbols: Ie, getPrototypeOf: je } = Object, A = globalThis, Z = A.trustedTypes, ze = Z ? Z.emptyScript : "", X = A.reactiveElementPolyfillSupport, w = (i, e) => i, B = { toAttribute(i, e) {
  switch (e) {
    case Boolean:
      i = i ? ze : null;
      break;
    case Object:
    case Array:
      i = i == null ? i : JSON.stringify(i);
  }
  return i;
}, fromAttribute(i, e) {
  let t = i;
  switch (e) {
    case Boolean:
      t = i !== null;
      break;
    case Number:
      t = i === null ? null : Number(i);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(i);
      } catch {
        t = null;
      }
  }
  return t;
} }, pe = (i, e) => !Me(i, e), Q = { attribute: !0, type: String, converter: B, reflect: !1, hasChanged: pe };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), A.litPropertyMetadata ?? (A.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class $ extends HTMLElement {
  static addInitializer(e) {
    this._$Ei(), (this.l ?? (this.l = [])).push(e);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e, t = Q) {
    if (t.state && (t.attribute = !1), this._$Ei(), this.elementProperties.set(e, t), !t.noAccessor) {
      const a = Symbol(), n = this.getPropertyDescriptor(e, a, t);
      n !== void 0 && He(this.prototype, e, n);
    }
  }
  static getPropertyDescriptor(e, t, a) {
    const { get: n, set: r } = xe(this.prototype, e) ?? { get() {
      return this[t];
    }, set(s) {
      this[t] = s;
    } };
    return { get() {
      return n == null ? void 0 : n.call(this);
    }, set(s) {
      const m = n == null ? void 0 : n.call(this);
      r.call(this, s), this.requestUpdate(e, m, a);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) ?? Q;
  }
  static _$Ei() {
    if (this.hasOwnProperty(w("elementProperties"))) return;
    const e = je(this);
    e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(w("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(w("properties"))) {
      const t = this.properties, a = [...Re(t), ...Ie(t)];
      for (const n of a) this.createProperty(n, t[n]);
    }
    const e = this[Symbol.metadata];
    if (e !== null) {
      const t = litPropertyMetadata.get(e);
      if (t !== void 0) for (const [a, n] of t) this.elementProperties.set(a, n);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t, a] of this.elementProperties) {
      const n = this._$Eu(t, a);
      n !== void 0 && this._$Eh.set(n, t);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e) {
    const t = [];
    if (Array.isArray(e)) {
      const a = new Set(e.flat(1 / 0).reverse());
      for (const n of a) t.unshift(Y(n));
    } else e !== void 0 && t.push(Y(e));
    return t;
  }
  static _$Eu(e, t) {
    const a = t.attribute;
    return a === !1 ? void 0 : typeof a == "string" ? a : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var e;
    this._$ES = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (e = this.constructor.l) == null || e.forEach((t) => t(this));
  }
  addController(e) {
    var t;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(e), this.renderRoot !== void 0 && this.isConnected && ((t = e.hostConnected) == null || t.call(e));
  }
  removeController(e) {
    var t;
    (t = this._$EO) == null || t.delete(e);
  }
  _$E_() {
    const e = /* @__PURE__ */ new Map(), t = this.constructor.elementProperties;
    for (const a of t.keys()) this.hasOwnProperty(a) && (e.set(a, this[a]), delete this[a]);
    e.size > 0 && (this._$Ep = e);
  }
  createRenderRoot() {
    const e = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return Oe(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var e;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((t) => {
      var a;
      return (a = t.hostConnected) == null ? void 0 : a.call(t);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$EO) == null || e.forEach((t) => {
      var a;
      return (a = t.hostDisconnected) == null ? void 0 : a.call(t);
    });
  }
  attributeChangedCallback(e, t, a) {
    this._$AK(e, a);
  }
  _$EC(e, t) {
    var a;
    const n = this.constructor.elementProperties.get(e), r = this.constructor._$Eu(e, n);
    if (r !== void 0 && n.reflect === !0) {
      const s = (((a = n.converter) == null ? void 0 : a.toAttribute) !== void 0 ? n.converter : B).toAttribute(t, n.type);
      this._$Em = e, s == null ? this.removeAttribute(r) : this.setAttribute(r, s), this._$Em = null;
    }
  }
  _$AK(e, t) {
    var a;
    const n = this.constructor, r = n._$Eh.get(e);
    if (r !== void 0 && this._$Em !== r) {
      const s = n.getPropertyOptions(r), m = typeof s.converter == "function" ? { fromAttribute: s.converter } : ((a = s.converter) == null ? void 0 : a.fromAttribute) !== void 0 ? s.converter : B;
      this._$Em = r, this[r] = m.fromAttribute(t, s.type), this._$Em = null;
    }
  }
  requestUpdate(e, t, a) {
    if (e !== void 0) {
      if (a ?? (a = this.constructor.getPropertyOptions(e)), !(a.hasChanged ?? pe)(this[e], t)) return;
      this.P(e, t, a);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(e, t, a) {
    this._$AL.has(e) || this._$AL.set(e, t), a.reflect === !0 && this._$Em !== e && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(e);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (t) {
      Promise.reject(t);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [r, s] of this._$Ep) this[r] = s;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [r, s] of n) s.wrapped !== !0 || this._$AL.has(r) || this[r] === void 0 || this.P(r, this[r], s);
    }
    let t = !1;
    const a = this._$AL;
    try {
      t = this.shouldUpdate(a), t ? (this.willUpdate(a), (e = this._$EO) == null || e.forEach((n) => {
        var r;
        return (r = n.hostUpdate) == null ? void 0 : r.call(n);
      }), this.update(a)) : this._$EU();
    } catch (n) {
      throw t = !1, this._$EU(), n;
    }
    t && this._$AE(a);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var t;
    (t = this._$EO) == null || t.forEach((a) => {
      var n;
      return (n = a.hostUpdated) == null ? void 0 : n.call(a);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((t) => this._$EC(t, this[t]))), this._$EU();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
}
$.elementStyles = [], $.shadowRootOptions = { mode: "open" }, $[w("elementProperties")] = /* @__PURE__ */ new Map(), $[w("finalized")] = /* @__PURE__ */ new Map(), X == null || X({ ReactiveElement: $ }), (A.reactiveElementVersions ?? (A.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const x = globalThis, R = x.trustedTypes, ee = R ? R.createPolicy("lit-html", { createHTML: (i) => i }) : void 0, ge = "$lit$", g = `lit$${Math.random().toFixed(9).slice(2)}$`, Ne = "?" + g, Ge = `<${Ne}>`, f = document, k = () => f.createComment(""), C = (i) => i === null || typeof i != "object" && typeof i != "function", V = Array.isArray, Be = (i) => V(i) || typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", G = `[ 	
\f\r]`, S = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, te = /-->/g, ae = />/g, N = RegExp(`>|${G}(?:([^\\s"'>=/]+)(${G}*=${G}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), ne = /'/g, ie = /"/g, _e = /^(?:script|style|textarea|title)$/i, y = Symbol.for("lit-noChange"), c = Symbol.for("lit-nothing"), se = /* @__PURE__ */ new WeakMap(), _ = f.createTreeWalker(f, 129);
function fe(i, e) {
  if (!V(i) || !i.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return ee !== void 0 ? ee.createHTML(e) : e;
}
const Ke = (i, e) => {
  const t = i.length - 1, a = [];
  let n, r = e === 2 ? "<svg>" : e === 3 ? "<math>" : "", s = S;
  for (let m = 0; m < t; m++) {
    const o = i[m];
    let h, u, l = -1, d = 0;
    for (; d < o.length && (s.lastIndex = d, u = s.exec(o), u !== null); ) d = s.lastIndex, s === S ? u[1] === "!--" ? s = te : u[1] !== void 0 ? s = ae : u[2] !== void 0 ? (_e.test(u[2]) && (n = RegExp("</" + u[2], "g")), s = N) : u[3] !== void 0 && (s = N) : s === N ? u[0] === ">" ? (s = n ?? S, l = -1) : u[1] === void 0 ? l = -2 : (l = s.lastIndex - u[2].length, h = u[1], s = u[3] === void 0 ? N : u[3] === '"' ? ie : ne) : s === ie || s === ne ? s = N : s === te || s === ae ? s = S : (s = N, n = void 0);
    const p = s === N && i[m + 1].startsWith("/>") ? " " : "";
    r += s === S ? o + Ge : l >= 0 ? (a.push(h), o.slice(0, l) + ge + o.slice(l) + g + p) : o + g + (l === -2 ? m : p);
  }
  return [fe(i, r + (i[t] || "<?>") + (e === 2 ? "</svg>" : e === 3 ? "</math>" : "")), a];
};
class U {
  constructor({ strings: e, _$litType$: t }, a) {
    let n;
    this.parts = [];
    let r = 0, s = 0;
    const m = e.length - 1, o = this.parts, [h, u] = Ke(e, t);
    if (this.el = U.createElement(h, a), _.currentNode = this.el.content, t === 2 || t === 3) {
      const l = this.el.content.firstChild;
      l.replaceWith(...l.childNodes);
    }
    for (; (n = _.nextNode()) !== null && o.length < m; ) {
      if (n.nodeType === 1) {
        if (n.hasAttributes()) for (const l of n.getAttributeNames()) if (l.endsWith(ge)) {
          const d = u[s++], p = n.getAttribute(l).split(g), T = /([.?@])?(.*)/.exec(d);
          o.push({ type: 1, index: r, name: T[2], strings: p, ctor: T[1] === "." ? Fe : T[1] === "?" ? Ve : T[1] === "@" ? We : j }), n.removeAttribute(l);
        } else l.startsWith(g) && (o.push({ type: 6, index: r }), n.removeAttribute(l));
        if (_e.test(n.tagName)) {
          const l = n.textContent.split(g), d = l.length - 1;
          if (d > 0) {
            n.textContent = R ? R.emptyScript : "";
            for (let p = 0; p < d; p++) n.append(l[p], k()), _.nextNode(), o.push({ type: 2, index: ++r });
            n.append(l[d], k());
          }
        }
      } else if (n.nodeType === 8) if (n.data === Ne) o.push({ type: 2, index: r });
      else {
        let l = -1;
        for (; (l = n.data.indexOf(g, l + 1)) !== -1; ) o.push({ type: 7, index: r }), l += g.length - 1;
      }
      r++;
    }
  }
  static createElement(e, t) {
    const a = f.createElement("template");
    return a.innerHTML = e, a;
  }
}
function b(i, e, t = i, a) {
  var n, r;
  if (e === y) return e;
  let s = a !== void 0 ? (n = t.o) == null ? void 0 : n[a] : t.l;
  const m = C(e) ? void 0 : e._$litDirective$;
  return (s == null ? void 0 : s.constructor) !== m && ((r = s == null ? void 0 : s._$AO) == null || r.call(s, !1), m === void 0 ? s = void 0 : (s = new m(i), s._$AT(i, t, a)), a !== void 0 ? (t.o ?? (t.o = []))[a] = s : t.l = s), s !== void 0 && (e = b(i, s._$AS(i, e.values), s, a)), e;
}
class De {
  constructor(e, t) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    const { el: { content: t }, parts: a } = this._$AD, n = ((e == null ? void 0 : e.creationScope) ?? f).importNode(t, !0);
    _.currentNode = n;
    let r = _.nextNode(), s = 0, m = 0, o = a[0];
    for (; o !== void 0; ) {
      if (s === o.index) {
        let h;
        o.type === 2 ? h = new P(r, r.nextSibling, this, e) : o.type === 1 ? h = new o.ctor(r, o.name, o.strings, this, e) : o.type === 6 && (h = new qe(r, this, e)), this._$AV.push(h), o = a[++m];
      }
      s !== (o == null ? void 0 : o.index) && (r = _.nextNode(), s++);
    }
    return _.currentNode = f, n;
  }
  p(e) {
    let t = 0;
    for (const a of this._$AV) a !== void 0 && (a.strings !== void 0 ? (a._$AI(e, a, t), t += a.strings.length - 2) : a._$AI(e[t])), t++;
  }
}
class P {
  get _$AU() {
    var e;
    return ((e = this._$AM) == null ? void 0 : e._$AU) ?? this.v;
  }
  constructor(e, t, a, n) {
    this.type = 2, this._$AH = c, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = a, this.options = n, this.v = (n == null ? void 0 : n.isConnected) ?? !0;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return t !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = t.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, t = this) {
    e = b(this, e, t), C(e) ? e === c || e == null || e === "" ? (this._$AH !== c && this._$AR(), this._$AH = c) : e !== this._$AH && e !== y && this._(e) : e._$litType$ !== void 0 ? this.$(e) : e.nodeType !== void 0 ? this.T(e) : Be(e) ? this.k(e) : this._(e);
  }
  O(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  T(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
  }
  _(e) {
    this._$AH !== c && C(this._$AH) ? this._$AA.nextSibling.data = e : this.T(f.createTextNode(e)), this._$AH = e;
  }
  $(e) {
    var t;
    const { values: a, _$litType$: n } = e, r = typeof n == "number" ? this._$AC(e) : (n.el === void 0 && (n.el = U.createElement(fe(n.h, n.h[0]), this.options)), n);
    if (((t = this._$AH) == null ? void 0 : t._$AD) === r) this._$AH.p(a);
    else {
      const s = new De(r, this), m = s.u(this.options);
      s.p(a), this.T(m), this._$AH = s;
    }
  }
  _$AC(e) {
    let t = se.get(e.strings);
    return t === void 0 && se.set(e.strings, t = new U(e)), t;
  }
  k(e) {
    V(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let a, n = 0;
    for (const r of e) n === t.length ? t.push(a = new P(this.O(k()), this.O(k()), this, this.options)) : a = t[n], a._$AI(r), n++;
    n < t.length && (this._$AR(a && a._$AB.nextSibling, n), t.length = n);
  }
  _$AR(e = this._$AA.nextSibling, t) {
    var a;
    for ((a = this._$AP) == null ? void 0 : a.call(this, !1, !0, t); e && e !== this._$AB; ) {
      const n = e.nextSibling;
      e.remove(), e = n;
    }
  }
  setConnected(e) {
    var t;
    this._$AM === void 0 && (this.v = e, (t = this._$AP) == null || t.call(this, e));
  }
}
class j {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e, t, a, n, r) {
    this.type = 1, this._$AH = c, this._$AN = void 0, this.element = e, this.name = t, this._$AM = n, this.options = r, a.length > 2 || a[0] !== "" || a[1] !== "" ? (this._$AH = Array(a.length - 1).fill(new String()), this.strings = a) : this._$AH = c;
  }
  _$AI(e, t = this, a, n) {
    const r = this.strings;
    let s = !1;
    if (r === void 0) e = b(this, e, t, 0), s = !C(e) || e !== this._$AH && e !== y, s && (this._$AH = e);
    else {
      const m = e;
      let o, h;
      for (e = r[0], o = 0; o < r.length - 1; o++) h = b(this, m[a + o], t, o), h === y && (h = this._$AH[o]), s || (s = !C(h) || h !== this._$AH[o]), h === c ? e = c : e !== c && (e += (h ?? "") + r[o + 1]), this._$AH[o] = h;
    }
    s && !n && this.j(e);
  }
  j(e) {
    e === c ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
}
class Fe extends j {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === c ? void 0 : e;
  }
}
class Ve extends j {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    this.element.toggleAttribute(this.name, !!e && e !== c);
  }
}
class We extends j {
  constructor(e, t, a, n, r) {
    super(e, t, a, n, r), this.type = 5;
  }
  _$AI(e, t = this) {
    if ((e = b(this, e, t, 0) ?? c) === y) return;
    const a = this._$AH, n = e === c && a !== c || e.capture !== a.capture || e.once !== a.once || e.passive !== a.passive, r = e !== c && (a === c || n);
    n && this.element.removeEventListener(this.name, this, a), r && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var t;
    typeof this._$AH == "function" ? this._$AH.call(((t = this.options) == null ? void 0 : t.host) ?? this.element, e) : this._$AH.handleEvent(e);
  }
}
class qe {
  constructor(e, t, a) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = a;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    b(this, e);
  }
}
const re = x.litHtmlPolyfillSupport;
re == null || re(U, P), (x.litHtmlVersions ?? (x.litHtmlVersions = [])).push("3.2.0");
const Je = (i, e, t) => {
  const a = (t == null ? void 0 : t.renderBefore) ?? e;
  let n = a._$litPart$;
  if (n === void 0) {
    const r = (t == null ? void 0 : t.renderBefore) ?? null;
    a._$litPart$ = n = new P(e.insertBefore(k(), r), r, void 0, t ?? {});
  }
  return n._$AI(i), n;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class M extends $ {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var e;
    const t = super.createRenderRoot();
    return (e = this.renderOptions).renderBefore ?? (e.renderBefore = t.firstChild), t;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this.o = Je(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this.o) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this.o) == null || e.setConnected(!1);
  }
  render() {
    return y;
  }
}
var oe;
M._$litElement$ = !0, M.finalized = !0, (oe = globalThis.litElementHydrateSupport) == null || oe.call(globalThis, { LitElement: M });
const le = globalThis.litElementPolyfillSupport;
le == null || le({ LitElement: M });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
function Ye(i, e, t) {
  const a = t ? `${e}-${t}` : e;
  customElements.get(a) ? console.warn(
    `WARN: You are importing '${a}' more than once, which is not supported. Please remove the duplicated import.`
  ) : customElements.define(a, i);
}
const Qe = (i) => Ye(Pe, Ue, i);
export {
  Pe as L,
  Qe as r
};
